import React, { useRef, useState } from "react";
import emailjs from "emailjs-com";

import logo from "../../assets/logofooter.png";
import insta from "../../assets/instagram.png";
import linkedin from "../../assets/linkedin.png";
import { toast } from "react-toastify";

export default function Footer() {
  const form = useRef();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const locations = [
    { name: "Amsterdam", url: "https://maps.app.goo.gl/ZDL2uomm4ohqjK1N6" },
    { name: "Berlin",    url: "https://maps.app.goo.gl/ATQUzedhxjMrD46M9"    },
    { name: "Boston",    url: "https://www.google.com/maps/search/?api=1&query=Boston%2C+MA" },
    { name: "Istanbul",  url: "https://maps.app.goo.gl/wYBWzJCUgXvfQydj6"  },
  ];
  const sendEmail = (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Please enter your email before sending.");
      return;
    }

    emailjs
      .sendForm(
        "service_xc7k1lm",   // EmailJS Service ID
        "template_2izgmfz",  // EmailJS Template ID
        form.current,
        "IxGTrMR_waKToa3H9"    // EmailJS Public Key
      )
      .then(
        () => {
          toast.success("Your message was sent successfully! 🎉");
          setEmail("");
          setMessage("");
        },
        (error) => {
          console.log("Mail gönderim hatası:", error.text);
          toast.error("Something went wrong. Please try again.");
        }
      );
  };

  return (
    <footer className="bg-white border-t border-gray-200 pt-16 pb-6 px-4 w-full" id="footer">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-start">
        {/* Sol: Let’s Talk */}
        <div>
          <h2 className="text-[62px] font-bold text-[#22282B] mb-3 font-manrope text-center md:text-left">
            Let’s Talk
          </h2>
          <p className="text-[#22282B] font-manrope text-[18px] font-normal mb-6 text-sm text-center md:text-left">
            Have questions or a project idea?<br />Let’s start the conversation:
          </p>

          <form
  ref={form}
  onSubmit={sendEmail}
  className="flex flex-col space-y-6 w-full max-w-md"
>
  {/* Email Field */}
  <div className="flex flex-col">
    <label
      htmlFor="user_email"
      className="text-[#22282B] font-manrope text-sm mb-1"
    >
      E-mail
    </label>
    <input
      id="user_email"
      type="email"
      name="user_email"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      placeholder="Write your email..."
      className="w-full px-4 py-2 bg-gray-100 text-[#22282B] placeholder:text-[#22282B] rounded-full outline-none text-sm"
      required
    />
  </div>

  {/* Message Field */}
  <div className="flex flex-col">
    <label
      htmlFor="message"
      className="text-[#22282B] font-manrope text-sm mb-1"
    >
      Message
    </label>
    <div className="flex overflow-hidden rounded-full bg-gray-100">
      <input
        id="message"
        type="text"
        name="message"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Write your message..."
        className="flex-1 px-4 py-2 bg-transparent text-[#22282B] placeholder:text-[#22282B] outline-none text-sm"
        required
      />
      <button
        type="submit"
        className="bg-[#22282B] text-white text-sm font-medium px-5 py-3 rounded-full"
      >
        Send an inquiry
      </button>
    </div>
  </div>
</form>

        </div>

        {/* Sağ: Locations + Contact */}
        <div className="flex flex-col gap-8 md:flex-row md:justify-between mt-10">
          <div className="flex flex-row justify-between w-full">
            {/* Şehirler */}
            <div className=" space-y-5">
            <div className="space-y-5">
  {locations.map(({ name, url }) => (
    <a
      key={name}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
    >
      <h4 className="text-[#667085] font-questrial font-bold text-[18px] uppercase">
        {name}
      </h4>
    </a>
  ))}
</div>

</div>

            {/* E-posta ve Sosyal */}
            <div className="text-sm text-right">
              <h4 className="text-[#667085] font-semibold mb-1">EMAIL</h4>
              <p className="text-[#22282B] mb-4">real@realminds.co</p>
              <p className="text-[#667085] mb-2">Let’s be social:</p>
              <div className="flex justify-end space-x-3">
                <a
                  href="https://www.instagram.com/realmindsco/"
                  target="_blank"
                  rel="noreferrer"
                  className="border p-2 border-gray-400 w-9 h-9 flex items-center justify-center rounded-full"
                >
                  <img src={insta} alt="insta" />
                </a>
                <a
                  href="https://www.linkedin.com/company/realminds/?originalSubdomain=tr"
                  target="_blank"
                  rel="noreferrer"
                  className="border p-2 border-gray-400 w-9 h-9 flex items-center justify-center rounded-full"
                >
                  <img src={linkedin} alt="link" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Alt Logo ve Telif */}
      <div className="mt-16 text-center">
        <img src={logo} alt="RealMinds" className="h-22 mx-auto mb-4" />
        <hr className="border-t border-[#22282B] my-4" />
        <p className="text-[16px] text-[#22282B]">
          © RealMinds 2026, All Rights Reserved
        </p>
      </div>
    </footer>
  );
}
